export const _TOGGLE_DARK_THEME = '_TOGGLE_DARK_THEME'

export const toggleDarkTheme = () => dispatch => dispatch({type: _TOGGLE_DARK_THEME})



// WEBPACK FOOTER //
// ./src/core/redux/action/themeAction.ts